import { BreakPoints, Button } from '@kanda-libs/ks-design-library';
import { Helmet } from 'components';
import TrustPilotRating from 'components/TrustPilotRating';
import { Layout } from '../components';
import { VideoEmbed } from './components';
import useSetupInfo from './useSetupInfo';

const SetupInfo: React.FunctionComponent = function () {
  const { onClick } = useSetupInfo();
  return (
    <Layout
      mobileFooter={
        <Button.Text
          id="setup-info-next"
          className="w-full"
          label="Apply Now and Pay"
          icon="arrow-right"
          variant="gradient"
          onClick={onClick}
        />
      }
    >
      <Helmet title="Ideal4Finance Info" />
      <div className="flex flex-col w-full max-w-120 md:max-w-full mx-auto">
        <VideoEmbed />
        <BreakPoints
          desktop={
            <Button.Text
              id="setup-rates-next"
              className="w-full max-w-80 mt-6 mx-auto"
              label="Apply Now and Pay"
              icon="arrow-right"
              variant="gradient"
              onClick={onClick}
            />
          }
        />
        <TrustPilotRating wrapperClassName="mt-10" />
      </div>
    </Layout>
  );
};

export default SetupInfo;
